// extracted by mini-css-extract-plugin
module.exports = {"withOnClickHandler":"_3TiYw"};